import { Alert, AlertTitle, Grid } from "@mui/material";
import { apolloErrorVar } from "@command-center-app/graphql/errorState";
import { useReactiveVar } from "@apollo/client";
import { colorPalette } from "@command-center-app/utils/colorPalette";
const ErrorFallback = ({ error }: { error: Error }) => {
  const apolloError = useReactiveVar(apolloErrorVar); // Get GraphQL errors

  return (
    <Grid sx={styles.container}>
      <h1 style={styles.heading}>Something went wrong.</h1>

      {/* Display React errors */}
      {error && (
        <Alert severity="error">
          <AlertTitle>React Error</AlertTitle>
          {error.message}
        </Alert>
      )}

      {/* Display Apollo (GraphQL) errors */}
      {apolloError && (
        <Alert severity="warning">
          <AlertTitle>GraphQL Error</AlertTitle>
          {apolloError.message}
        </Alert>
      )}

      <button onClick={() => window.location.reload()} style={styles.button}>
        Try Again
      </button>
    </Grid>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center" as const,
    backgroundColor: colorPalette.colorLightPinkishRed,
    color: colorPalette.colorDarkRed,
    padding: "20px",
    borderRadius: "8px",
  },
  heading: {
    fontSize: "24px",
    fontWeight: "bold",
  },
  button: {
    marginTop: "10px",
    padding: "10px 15px",
    backgroundColor: colorPalette.colorDarkRed,
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default ErrorFallback;
